<svelte:options accessors />

<script lang="ts" context="module">
	import type { OrderItem, OrderItemSection } from '$lib/config';

	export function isDiscounted(item: OrderItem) {
		return item.Price !== item.DiscountedPrice;
	}
</script>

<script lang="ts">
	import FormGroup from '../sub_components/FormGroup.svelte';
	import type { OrderFormConfig } from '$lib/config';
	import { onMount } from 'svelte';
	import { total } from '$lib/client/store';
	import type Modal from './Modal.svelte';
	import { CSS } from '$lib/client/css_ext';
	import * as Store from '$lib/client/store';
	import { REST } from '$lib/client/conn';
	import { KTIForm } from '$lib/client/form';
	import { amount, setAmount } from './CenPOS.svelte';
	import * as _ from 'lodash';
	import { FormController } from '../actions';

	export let ReadOnly: boolean = false;
	export let Disabled: boolean = false;

	//export let Required: boolean;
	export let Config: OrderFormConfig;
	let showFloorDisplay = false;
	let addFloorDisplay = false;
	let moreThanOneSection = false;
	let ItemSections = Config.Items;
	let section_states: { valid: validity; err_msg: string; section_div: HTMLDivElement }[] = [];
	type validity = 'valid' | 'invalid' | 'pending';
	onMount(async () => {
		//initialize items
		for (let item of Config.Items) {
			item.el = null;
		}
		CSS.onResize(onResize);

		moreThanOneSection = Config.Items.length > 1;

		for (let section of Config.Items) {
			section_states.push({
				valid: 'pending',
				err_msg: 'Please complete this section',
				section_div: null
			});
		}

		subtotal = 0;
		for (let section of Config.Items) {
			for (let item of section.Items) {
				if (item.Qty) {
					item.Total = item.Qty * item.DiscountedPrice;
					subtotal += item.Total;
				}
			}
		}

		// If shipping is always free, total is just the subtotal
		// If shipping costs are added later, you can include them in this calculation
		_total = subtotal;

		//Check if floor display is enabled
		if (Config.FloorDisplayLimit === null) {
			console.log('Config.FloorDisplayLimit is null');
			showFloorDisplay = true;
		} else if (Config.FloorDisplayLimit > 0) {
			// let url = new URL(PUBLIC_DOMAIN + '/api/count');
			// url.searchParams.append('column_name', 'floor_display');
			// url.searchParams.append('match_value', '1');
			const res = await REST.GET('count', { column_name: 'floor_display', match_value: '1' });
			const data = await res.json();
			if (data.count < Config.FloorDisplayLimit) {
				showFloorDisplay = true;
			}
		}
	});

	export let Valid = false;
	function formatColName(colName: string) {
		//format column name for SQL

		return colName.replaceAll('-', '_');
	}
	export async function validate(): Promise<boolean> {
		if (moreThanOneSection) {
			Valid = true;
			for (let i = 0; i < Config.Items.length; i++) {
				let sectionValid = validateSection(Config.Items[i], i);
				if (!sectionValid) {
					Valid = false;
				}
			}
		} else {
			//total of quantities
			let totalQty = 0;
			for (let section of Config.Items) {
				let sectionQty = 0;
				for (let item of section.Items) {
					let itemQty = item.Qty ?? 0;
					if (itemQty > item.MaxQty || itemQty < item.MinQty) {
						//Show error somehow
						return false;
					}

					sectionQty += itemQty;
				}
				totalQty += sectionQty;
			}
			Valid = totalQty > 0;
		}
		if (Valid) {
			//let CenPOSComp = FormController.get_component(Config.CenPOSId).Comp;
			setAmount(_total.toFixed(2));
			Store.formData.setValue('amount', _total.toFixed(2));
		}
		return Valid;
	}
	export function appendData(formData: FormData) {
		//Save total to global store
		total.set(_total);
		for (let section of Config.Items) {
			for (let item of section.Items) {
				formData.append('qty_' + formatColName(item.SKU), (item.Qty ?? 0).toString());
				formData.append('price_' + formatColName(item.SKU), item.DiscountedPrice.toString());
			}
		}
		//formData.append('trans_amount', _total.toFixed(2));
		formData.append('amount', _total.toFixed(2));
		if (Config.FloorDisplay) {
			formData.append('floor_display', addFloorDisplay.toString());
		}
	}
	let items: { [key: number]: HTMLElement } = {};
	let itemImgs: { [key: number]: HTMLImageElement } = {};
	export function focus() {
		if (moreThanOneSection) {
			//Find first invalid section
			for (let i = 0; i < Config.Items.length; i++) {
				if (section_states[i].valid === 'invalid') {
					section_states[i].section_div.focus();
					return;
				}
			}
		}
		//else
		for (let i = 0; i < Config.Items.length; i++) {
			if (Config.Items[i].Qty == 0) {
				items[i].focus();
				return;
			}
		}
	}
	export function showError() {
		if (!Valid) {
			setTimeout(() => {
				KTIForm.error_modal.Show('Select an item to order');
			}, 300);
		}
	}
	let subtotal = 0;
	let _total = 0;
	function validateQty(event: Event, item: OrderItem) {
		let target = event.target as HTMLInputElement;
		//remove any non-numeric characters
		target.value = target.value.replace(/\D/g, '');
		if (target.valueAsNumber < item.MinQty) {
			target.value = item.MinQty.toString();
			item.Qty = item.MinQty;
		}
		if (target.valueAsNumber > item.MaxQty) {
			target.value = item.MaxQty.toString();
			item.Qty = item.MaxQty;
		}
		item.Total = ((item.Qty ?? 0) * item.DiscountedPrice) / item.QtyPerPrice;
		Config = Config;
		// A derived value that recalculates whenever Config.Items changes
		subtotal = 0;
		for (let section of Config.Items) {
			subtotal += section.Items.reduce((acc, item) => acc + (item.Total ?? 0), 0);
		}

		// If shipping is always free, total is just the subtotal
		// If shipping costs are added later, you can include them in this calculation
		_total = subtotal;
		ItemSections = ItemSections;
	}
	function onResize() {
		let newWidth = CSS.getWidth(120, 180, 500, 644);
		// for (let image of Object.values(itemImgs)) {
		// 	if (image) {
		// 		image.style.width = `${newWidth}px`;
		// 	}
		// }
	}
	function validateSection(section: OrderItemSection, i: number): boolean {
		let totalQty = 0;
		section_states[i].valid = 'pending';
		for (let item of section.Items) {
			if (item.Qty) {
				if (item.Qty > item.MaxQty) {
					section_states[i].valid = 'invalid';
					section_states[
						i
					].err_msg = `${item.Description}'s' quantity exceeds the maximum allowed (${item.MaxQty})`;
				} else if (item.Qty < item.MinQty) {
					section_states[i].valid = 'invalid';
					section_states[
						i
					].err_msg = `${item.Description}'s' quantity is below the minimum allowed (${item.MinQty})`;
				}
				totalQty += item.Qty;
			}
		}
		if (section.MaxQty && totalQty > section.MaxQty) {
			section_states[i].valid = 'invalid';
			section_states[i].err_msg = `Total quantity exceeds the maximum allowed (${section.MaxQty})`;
		}
		if (section.MinQty && totalQty < section.MinQty) {
			if (totalQty === 0) {
				section_states[i].valid = 'invalid';
				section_states[i].err_msg = `Please select at least 1 item`;
			} else {
				section_states[i].valid = 'invalid';
				section_states[
					i
				].err_msg = `Total quantity is below the minimum allowed (${section.MinQty})`;
			}
		}
		if (section_states[i].valid === 'pending') {
			section_states[i].valid = 'valid';
		}
		section_states = section_states;
		return section_states[i].valid === 'valid';
	}

	let currentFocusSectionNum: number | null = null;
	let currentFocusSection: OrderItemSection | null = null;
	function handleFocusChange(section: OrderItemSection, i: number) {
		//If changing section, validate the blurred section
		if (currentFocusSection && currentFocusSectionNum && currentFocusSectionNum !== i) {
			console.log('new section focused');
			validateSection(currentFocusSection, currentFocusSectionNum);
		}
		currentFocusSectionNum = i;
		currentFocusSection = section;
	}
	function isSectionBlurred(section: OrderItemSection, i: number) {
		//check if div has tabindex of -1
		if (section_states[i].section_div === null) {
			return true;
		}
		if (section_states[i].section_div.tabIndex !== -1) {
			console.error('section_div tabindex is not -1');
			return true;
		}
		//SPECIAL CASE: if is body return false because HTML can be dumb sometimes?
		if (document.activeElement?.tagName === 'BODY') {
			return true;
		}
		return !section_states[i].section_div.contains(document.activeElement);
	}
	function handleSectionBlur(section: OrderItemSection, i: number) {
		console.log('section blurred');
		//wait a bit because we could be blurring to another item in the same section
		setTimeout(() => {
			//Is section still blurred?
			if (isSectionBlurred(section, i)) {
				console.log('section was blurred');
				validateSection(section, i);
			}
			if (currentFocusSectionNum === i) {
				return;
			}
			//validateSection(section, i);
		}, 10);
	}
	function removeInvalidIfPossible(section: OrderItemSection, i: number) {
		if (section_states[i].valid === 'invalid') {
			validateSection(section, i);
		}
	}
</script>

<FormGroup {Config}>
	{#if Config.Title}
		<div class="title3">
			{@html Config.Title}
		</div>
	{/if}
	{#if Config.HeaderHTML}
		{@html Config.HeaderHTML}
	{/if}
	{#if moreThanOneSection}
		{#each ItemSections as section, i}
			{#if section_states && section_states[i]}
				{#if section.Hint}
					<div class="alert alert-info" role="alert">{@html section.Hint}</div>
					<!-- <p class="text-primary mb-1"><small>{@html section.Hint}</small></p> -->
				{/if}
				<div
					class="card mb-3"
					style={`background-color: ${section.BGColor ?? ''}; ${
						section_states[i].valid === 'invalid'
							? 'border: solid red 1px; border-radius: 5px;'
							: ''
					}`}
					bind:this={section_states[i].section_div}
					tabindex="-1"
					on:focusin={() => {
						console.log('focused in');
						handleFocusChange(section, i);
					}}
					on:focusout={() => {
						console.log('focused out');
						handleSectionBlur(section, i);
					}}
				>
					{#if section.Title}
						<div class="card-header">
							<h5 class="mb-0">{section.Title}</h5>
						</div>
					{/if}
					<div class="card-body">
						{#each section.Items as item, j}
							{#if item.Title}
								<div class="card-header mb-2" style="padding: 5px;">
									<h5 class="mb-0" style="margin-bottom:0px">{@html item.Title}</h5>
								</div>
							{/if}
							<div class="col-12 mb-3">
								<div class="d-flex justify-content-start align-items-start">
									<!-- Image container -->
									<div class="flex-shrink-0 mr-3" style="margin-right:15px">
										<img
											src={item.ImageURL}
											alt="Item"
											class="item_img_small"
											bind:this={itemImgs[j]}
										/>
									</div>
									<!-- Item Description and Details -->
									<div class="flex-grow-1">
										<h6 style="margin-bottom:0px">{@html item.Description}</h6>
										{#if item.SubTitle}
											<div style="margin-top: 7px;">
												{@html item.SubTitle}
											</div>
										{/if}
										{#if item.ShowSKU}
											<p class="card-text part_group">Part #: {item.SKU}</p>
										{/if}
										{#if item.ShowPrice}
											<p class="card-text price_group">
												{#if isDiscounted(item)}
													<span class="old-price">${item.Price.toFixed(2)}</span>
													<strong>${item.DiscountedPrice.toFixed(2)}</strong>
												{:else}
													<strong>${item.Price.toFixed(2)}</strong>
												{/if}
											</p>
										{/if}
										{#if item.ShowShipping}
											{#if item.Shipping === 0}
												<p class="card-text shipping">Free Shipping</p>
											{:else}
												<p class="card-text shipping">Shipping: ${item.Shipping}</p>
											{/if}
										{/if}
									</div>
									<!-- Free Shipping and Quantity/Total now in the same container -->
									<div class="d-flex justify-content-between qty_total_group">
										<!-- Quantity and Total aligned to the right -->
										{#if item.QtySelector === 'dropdown'}
											<div class="qty_container">
												<label for="quantity">Qty:</label>
												<select
													name="quantity"
													class="form-control d-inline-block"
													style="width: 60px; appearance: auto;"
													bind:value={item.Qty}
													bind:this={items[j]}
													on:change={(e) => {
														validateQty(e, item);
														removeInvalidIfPossible(section, i);
													}}
												>
													{#each _.range(item.MinQty, item.MaxQty + 1, item.QtyIncrement) as k}
														<option value={k} selected={item.Qty === k}>{k}</option>
													{/each}
													disabled={item.MaxQty === item.MinQty}
												</select>
											</div>
										{:else if item.QtySelector === 'number' && item.QtyIncrement === 1}
											<div class="qty_container" style="width: 168px">
												<label for="quantity">Qty:</label>
												<input
													name="quantity"
													type="number"
													class="form-control d-inline-block"
													style="width: 60px;"
													min={item.MinQty}
													max={item.MaxQty}
													on:blur={() => {
														handleSectionBlur(section, i);
													}}
													on:focus={() => {
														handleFocusChange(section, i);
													}}
													bind:value={item.Qty}
													bind:this={items[j]}
													step={item.QtyIncrement}
													on:input={(e) => validateQty(e, item)}
													disabled={item.MaxQty === item.MinQty}
												/>
											</div>
										{:else}
											Unsupported QtySelector and QtyIncrement arguments
										{/if}
										{#if item.ShowTotal}
											<div class="total-container" style="width: 100%; text-align: right;">
												<!-- Display total; assuming you will calculate this via JavaScript -->
												<p class="card-text">
													<strong
														>{item.TotalTerm}: ${typeof item.Total === 'number'
															? item.Total.toFixed(2)
															: '0.00'}</strong
													>
												</p>
											</div>
										{/if}
									</div>
									<!-- IF QtyFree is not null/undefined: Same as Qty except it's 'Qty Free' with a readonly qty = to floor(Qty/QtyFree.Ratio) * QtyFree.FreeQty. Instead of 'Total' show 'Savings' (calculated from Price - DiscountPrice) -->
									{#if item.QtyFree}
										<div class="d-flex justify-content-between qty_total_group">
											<div class="d-flex qty-field">
												<label for="quantityFree" style="margin-right: 5px;">Qty Free:</label>
												<input
													name="quantityFree"
													type="text"
													class="form-control d-inline-block"
													style="width: 40px;"
													value={Math.floor((item.Qty ?? 0) / item.QtyFree.Ratio) *
														item.QtyFree.FreeQty}
													readonly
													disabled
												/>
											</div>
											<div style="width: 100%; text-align: right;">
												<p class="card-text">
													<strong
														>Savings: ${(
															(item.Price - item.DiscountedPrice) *
															Math.floor((item.Qty ?? 0) / item.QtyFree.Ratio) *
															item.QtyFree.FreeQty
														).toFixed(2)}</strong
													>
												</p>
											</div>
										</div>
									{/if}
								</div>
							</div>
						{/each}
						<!-- Validity Indicator -->
						{#if section_states[i].valid === 'valid'}
							<!-- Valid -->
							<!-- <span class="badge badge-success">Valid</span> -->
						{:else if section_states[i].valid === 'invalid'}
							<span class="badge badge-danger" style="width: 100%; display: block;">
								{section_states[i].err_msg}
							</span>
						{/if}
					</div>
				</div>
			{/if}
		{/each}
	{:else}
		{#each ItemSections as section, i}
			{#each section.Items as item, j}
				<div class="col-12 mb-3">
					<div class="card">
						<div class="card-body">
							<div class="d-flex justify-content-start align-items-start">
								<!-- Image container -->
								<div class="flex-shrink-0 mr-3" style="margin-right:15px">
									<img src={item.ImageURL} alt="Item" class="item_img" bind:this={itemImgs[j]} />
								</div>
								<!-- Item Description and Details -->
								<div class="flex-grow-1">
									<h5 class="card-title" style="margin-bottom:0px">{@html item.Description}</h5>
									{#if item.SubTitle}
										<div style="margin-top: 7px;">
											{@html item.SubTitle}
										</div>
									{/if}
									{#if item.ShowSKU}
										<p class="card-text part_group">Part #: {item.SKU}</p>
									{/if}
									{#if item.ShowPrice}
										<p class="card-text price_group">
											{#if isDiscounted(item)}
												<span class="old-price">${item.Price.toFixed(2)}</span>
												<strong>${item.DiscountedPrice.toFixed(2)}</strong>
											{:else}
												<strong>${item.Price.toFixed(2)}</strong>
											{/if}
										</p>
									{/if}
									{#if item.Shipping === 0}
										<p class="card-text shipping">Free Shipping</p>
									{:else}
										<p class="card-text shipping">Shipping: ${item.Shipping}</p>
									{/if}
									<!-- Free Shipping and Quantity/Total now in the same container -->
									<div class="d-flex justify-content-between qty_total_group">
										<!-- Quantity and Total aligned to the right -->
										{#if item.QtySelector === 'dropdown'}
											<div>
												<label for="quantity">Qty:</label>
												<select
													name="quantity"
													class="form-control d-inline-block"
													style="width: 60px; appearance: auto;"
													bind:value={item.Qty}
													bind:this={items[j]}
													on:change={(e) => validateQty(e, item)}
												>
													{#each _.range(item.MinQty, item.MaxQty + 1, item.QtyIncrement) as k}
														<option value={k} selected={item.Qty === k}>{k}</option>
													{/each}
												</select>
											</div>
										{:else if item.QtySelector === 'number' && item.QtyIncrement === 1}
											<div style="width: 168px">
												<label for="quantity">Qty:</label>
												<input
													name="quantity"
													type="number"
													class="form-control d-inline-block"
													style="width: 60px;"
													min={item.MinQty}
													max={item.MaxQty}
													bind:value={item.Qty}
													bind:this={items[j]}
													step={item.QtyIncrement}
													on:input={(e) => validateQty(e, item)}
												/>
											</div>
										{:else}
											Unsupported QtySelector and QtyIncrement arguments
										{/if}
										<div style="width: 100%; text-align: right;">
											<!-- Display total; assuming you will calculate this via JavaScript -->
											<p class="card-text">
												<strong
													>{item.TotalTerm}: ${typeof item.Total === 'number'
														? item.Total.toFixed(2)
														: '0.00'}</strong
												>
											</p>
										</div>
									</div>
									<!-- IF QtyFree is not null/undefined: Same as Qty except it's 'Qty Free' with a readonly qty = to floor(Qty/QtyFree.Ratio) * QtyFree.FreeQty. Instead of 'Total' show 'Savings' (calculated from Price - DiscountPrice) -->
									{#if item.QtyFree}
										<div class="d-flex justify-content-between qty_total_group">
											<div class="d-flex qty-field">
												<label for="quantityFree" style="margin-right: 5px;">Qty Free:</label>
												<input
													name="quantityFree"
													type="text"
													class="form-control d-inline-block"
													style="width: 40px;"
													value={Math.floor((item.Qty ?? 0) / item.QtyFree.Ratio) *
														item.QtyFree.FreeQty}
													readonly
													disabled
												/>
											</div>
											<div style="width: 100%; text-align: right;">
												<p class="card-text">
													<strong
														>Savings: ${(
															(item.Price - item.DiscountedPrice) *
															Math.floor((item.Qty ?? 0) / item.QtyFree.Ratio) *
															item.QtyFree.FreeQty
														).toFixed(2)}</strong
													>
												</p>
											</div>
										</div>
									{/if}
								</div>
							</div>
						</div>
					</div>
				</div>
			{/each}
		{/each}
	{/if}
	<div class="mt-3">
		<div class="d-flex justify-content-end">
			<div style="width: 190px;">
				<div class="d-flex justify-content-between">
					<p class="card-text no_spacing">Subtotal:</p>
					<p class="card-text">${subtotal.toFixed(2)}</p>
					<!-- Display rounded subtotal -->
				</div>
				<div class="d-flex justify-content-between">
					<p class="card-text no_spacing">Total Shipping:</p>
					<p class="card-text">$0.00</p>
					<!-- Assuming free shipping for now -->
				</div>
				<div class="d-flex justify-content-between">
					<p class="card-text no_spacing"><strong>Total:</strong></p>
					<p class="card-text"><strong>${_total.toFixed(2)}</strong></p>
					<!-- Display rounded total -->
				</div>
			</div>
		</div>
	</div>
	<!-- Subtotal, Shipping, and Total Section with an additional column for content -->
	<div class="mt-5" style={Config.FloorDisplay && showFloorDisplay ? '' : 'display: none'}>
		<div class="d-flex justify-content-between" style="align-items: flex-start;">
			<!-- Additional content column -->
			<div style="flex-grow: 1; display: flex; align-items: flex-start; margin-right: 5px;">
				<!-- Checkbox and label -->

				<input
					class="form-check-input"
					type="checkbox"
					name="floorDisplay"
					style="margin-right: 10px; margin-top: 2px; min-width: 20px;"
					bind:checked={addFloorDisplay}
				/>
				<label for="floorDisplay" style="margin-right: 0px;">
					Send me one <strong>limited quantity, free</strong> Floor Display.<br />
					<span class="small">(Will be shipped separately)</span>
				</label>
				<!-- Floor Display Image -->
				<div
					style="margin-left:5px;display: flex; height: 200px; width: 200px; flex-shrink: 0; border-radius: 10px; overflow: hidden; border-width: 5px; box-shadow: 2px 2px 3px 2px rgba(0,0,0,0.15); justify-content: center; align-items: center;"
				>
					<img
						src={Config.FloorDisplayImage ?? ''}
						alt="Floor Display"
						style="max-height: 100%; max-width: 100%;"
					/>
				</div>
			</div>
		</div>
	</div>
</FormGroup>

<style>
	.qty_total_group {
		display: flex;
		justify-content: space-between;
		margin-top: 15px;
	}

	@media (max-width: 576px) {
		.badge {
			font-size: 0.8em;
		}
		.qty_total_group {
			flex-direction: column; /* Stack vertically */
			align-items: flex-start;
			gap: 5px;
		}
		.qty_container {
			text-align: right;
		}
		.total-container {
			text-align: left; /* Align total text to the left for consistency */
			margin-top: 0.5rem; /* Add spacing between qty and total */
		}
		.item_img_small {
			width: 40px;
		}
		.item_img {
			width: 80px;
		}
		.card-body {
			padding: 10px;
		}
		.qty-field {
			display: flex;
			align-items: flex-end;
		}
	}
	@media (min-width: 576px) {
		.badge {
			font-size: 1em;
		}
		.item_img_small {
			width: 60px;
		}
		.item_img {
			width: 120px;
		}
		.qty-field {
			display: flex;
			align-items: center;
		}
	}
	.item_img_small {
		width: 80px;
		-webkit-filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
		filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.3));
	}
	.item_img {
		-webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.3));
		filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.3));
	}
	.old-price {
		position: relative;
		color: grey;
	}
	.old-price::after {
		content: '';
		position: absolute;
		left: 0;
		top: 10%;
		right: 0;
		bottom: 0;
		width: 100%;
		height: 1px;
		background: red;
		transform: rotate(15deg);
		transform-origin: 0 0;
	}
	.shipping {
		margin-top: 0px;
		margin-bottom: 0px;
	}
	.price_group {
		margin-top: 0px;
		margin-bottom: 0px;
	}
	.part_group {
		margin-top: 0px;
		margin-bottom: 5px;
	}
	.no_spacing {
		margin: 0px;
	}
</style>
